import React, { useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../../../Axios'


const AddHostel = () => {
  const [formData, setFormData] = useState({
    hostelName: '',
    type: '',
    capacity: '',
    roomsAvailable: '',
    fees: '',
    facilities: '',
    address: '',
  });

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');

    try {
      const response = await api.post('/api/v1/hostels/adminhostels', formData);
      toast.success('Hostel added successfully!');
      setFormData({
        hostelName: '',
        type: '',
        capacity: '',
        roomsAvailable: '',
        fees: '',
        facilities: '',
        address: '',
      });
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Error adding hostel');
      toast.error(error.response?.data?.message || 'Error adding hostel');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-6">
      <motion.div
        className="bg-white shadow-xl rounded-lg p-10 w-full max-w-3xl"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h2
          className="text-3xl font-semibold text-white text-center py-4 mb-8 rounded-t-lg"
          style={{ backgroundColor: '#00BFA5' }}
        >
          Add New Hostel
        </h2>

        {errorMessage && (
          <div className="mb-4 text-red-600 text-sm">{errorMessage}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-gray-600 text-sm font-medium mb-2">
                Hostel Name
              </label>
              <input
                type="text"
                name="hostelName"
                value={formData.hostelName}
                onChange={handleChange}
                required
                className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
                placeholder="Enter hostel name"
              />
            </div>

            <div>
              <label className="block text-gray-600 text-sm font-medium mb-2">
                Hostel Type
              </label>
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
                required
                className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
              >
                <option value="">Select Type</option>
                <option value="boys">Boys Hostel</option>
                <option value="girls">Girls Hostel</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-600 text-sm font-medium mb-2">
                Total Capacity
              </label>
              <input
                type="number"
                name="capacity"
                value={formData.capacity}
                onChange={handleChange}
                required
                className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
                placeholder="Enter total capacity"
              />
            </div>

            <div>
              <label className="block text-gray-600 text-sm font-medium mb-2">
                Rooms Available
              </label>
              <input
                type="number"
                name="roomsAvailable"
                value={formData.roomsAvailable}
                onChange={handleChange}
                required
                className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
                placeholder="Enter available rooms"
              />
            </div>

            <div>
              <label className="block text-gray-600 text-sm font-medium mb-2">
                Fees (per semester)
              </label>
              <input
                type="number"
                name="fees"
                value={formData.fees}
                onChange={handleChange}
                required
                className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
                placeholder="Enter fees amount"
              />
            </div>
          </div>

          <div>
            <label className="block text-gray-600 text-sm font-medium mb-2">
              Facilities
            </label>
            <textarea
              name="facilities"
              value={formData.facilities}
              onChange={handleChange}
              className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
              rows="3"
              placeholder="Enter facilities separated by commas (e.g., Wi-Fi, Laundry, Mess)"
            />
          </div>

          <div>
            <label className="block text-gray-600 text-sm font-medium mb-2">
              Address
            </label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
              className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
              rows="2"
              placeholder="Enter hostel address"
            />
          </div>

          <div className="flex justify-center">
            <motion.button
              type="submit"
              className={`w-48 py-3 rounded-lg font-semibold shadow-md focus:outline-none focus:ring-2 ${
                loading
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-[#00BFA5] hover:bg-[#00BFA5] text-white'
              }`}
              disabled={loading}
              whileTap={{ scale: 0.98 }}
            >
              {loading ? 'Adding...' : 'Add Hostel'}
            </motion.button>
          </div>
        </form>
      </motion.div>
      <ToastContainer />
    </div>
  );
};

export default AddHostel;
